import { createBaseApi } from '../baseApi';

const mapDropApi = createBaseApi('mapDropApi');

export const enhancedMapDropApi = mapDropApi.injectEndpoints({
    endpoints: (builder) => ({
        getNearbyDrops: builder.query({
            query: ({ lat, lng, radius = 50 }) => ({
                url: `/map-drops`,
                params: { lat, lng, radius }
            }),
            providesTags: ['MapDrops']
        }),
        createDrop: builder.mutation({
            query: (data) => ({
                url: '/map-drops',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['MapDrops', 'Credits']
        }),
        collectDrop: builder.mutation({
            query: (dropId) => ({
                url: `/map-drops/${dropId}/collect`,
                method: 'PUT'
            }),
            invalidatesTags: ['MapDrops', 'Credits', 'Closets']
        }),
        recordOnSiteTryOn: builder.mutation({
            query: ({ dropId, virtualTryOnResultId }) => ({
                url: `/map-drops/${dropId}/on-site-try-on`,
                method: 'PUT',
                body: { virtualTryOnResultId }
            }),
            invalidatesTags: ['MapDrops', 'Credits']
        }),
        getMyClothes: builder.query({
            query: (userId) => `/closet-clothes?users_permissions_users=${userId}&_sort=created_at:desc`,
            providesTags: ['InCloset']
        }),
        getMyVTOResults: builder.query({
            query: (userId) => `/virtual-try-on-results?user=${userId}&_limit=100&_sort=created_at:desc`
        })
    }),
    overrideExisting: false
});

export const {
    useGetNearbyDropsQuery,
    useCreateDropMutation,
    useCollectDropMutation,
    useRecordOnSiteTryOnMutation,
    useGetMyClothesQuery,
    useGetMyVTOResultsQuery
} = enhancedMapDropApi;

export default enhancedMapDropApi;
